import { Box, Button, IconButton, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PublicIcon from "@mui/icons-material/Public";
import PublicOffIcon from "@mui/icons-material/PublicOff";
const TogglePublicBtn = ({
  isValidated,
  onToggle,
}: {
  isValidated: boolean;
  onToggle: () => void;
}) => {
  return (
    <Box
      sx={{
        padding: "0 10px",
      }}
    >
      {isValidated ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            sx={{
              textTransform: "unset",
              fontSize: "14px",
              border: "1px solid #00FF9C",
              color: "#15B392",
              fontWeight: "bold",
            }}
            color="primary"
            startIcon={<PublicIcon />}
            onClick={() => onToggle()}
          >
            Published
          </Button>
        </Box>
      ) : (
        <Button
          sx={{
            textTransform: "unset",
            fontSize: "14px",
            border: "1px solid #F95454",
            color: "#C62E2E",
            fontWeight: "bold",
          }}
          color="primary"
          startIcon={<PublicOffIcon />}
          onClick={() => onToggle()}
        >
          Not published
        </Button>
      )}
    </Box>
  );
};
export default TogglePublicBtn;
